<template>
    <div class='dwname'>
      <div class="headtitle">
        <img src="/apis/images/logo2.png" height="40vh"><span>{{dwname}}</span>
      </div>
        <div class='admin' style="float:right">
          <el-dropdown @command="handleCommand">
            <el-button icon="el-icon-info" circle></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="b" >修改密码</el-dropdown-item>
              <el-dropdown-item command="c" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <el-dialog title="修改密码" :visible.sync="dialogFormVisible">
          <el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
            <el-form-item label="新密码" prop="pass">
              <el-input type="password" v-model="ruleForm2.pass" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="checkPass">
              <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="resetForm('ruleForm2');">取 消</el-button>
              <el-button type="primary" @click="submitForm('ruleForm2');">确 定</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
  export default {
    computed:{
      dwname(){
        if (this.isadmin) return "系统管理总后台";
        else return this.$store.getters.dw + ' 道路运输从业人员继续教育平台';
      }
    },
    data() {
      var checkAge = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('原密码不能为空'));
        } else if (String(value).length < 6 || String(value).length > 16) {
          return callback(new Error('请输入6-16位密码'));
        } else callback();
      };
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入新密码'));
        } else if (String(value).length < 6 || String(value).length > 16) {
          return callback(new Error('请输入6-16位密码'));
        } else {
          if (this.ruleForm2.checkPass !== '') {
            this.$refs.ruleForm2.validateField('checkPass');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入新密码'));
        } else if (value !== this.ruleForm2.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else if (String(value).length < 6 || String(value).length > 16) {
          return callback(new Error('请输入6-16位密码'));
        } else callback();
      };
      return {
        isadmin:(this.$store.getters.name == 'admin'),
        dialogFormVisible:false,
        index:"home",
        ruleForm2: {
          pass: '',
          checkPass: '',
          age: ''
        },
        rules2: {
          pass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ]
        }
      };
    },

    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$message({showClose: true,message: '正在提交'});
            this.dialogFormVisible = false;
            this.editPass();
          } else {
            this.$message({showClose: true,message: '请检查填写内容',type: 'warning'});
            return false;
          }
        });
      },
      editPass(){
        var params = new URLSearchParams();
        params.append('token', 'pqgU1wqtfzcZRAniU');
        params.append('admin', this.$store.getters.name);
        params.append('my', this.$store.getters.token);
        params.append('id', this.$store.getters.id);
        params.append('newpassword', this.ruleForm2.pass);
        this.$ajax.post("/apis/admin.php",params).then((ret) => {
            console.log(ret.data)
            if (ret.data == true) {
              this.$notify.success({title: '密码已修改',message: '请重新登录'});
              this.resetForm('ruleForm2');
              this.$store.dispatch('FedLogOut');
            }else this.$notify.error({title: '错误',message: ret.data});
        }).catch(err=>{
            this.$notify.error({title: '错误',message: '网络异常'});
            this.resetForm('ruleForm2');
        });
      },
      resetForm(formName) {
        this.dialogFormVisible = false;
        this.$refs[formName].resetFields();
      },
      handleCommand(command) {
        if (command == "b") this.dialogFormVisible =true;
        if (command == "c") this.$store.dispatch('FedLogOut');
      },
      handleSelect(key, keyPath) {
        this.$store.state.headerIndex = key;
      }
    }
  }
</script>

<style scoped>
.headtitle{
  float:left;
  display: flex;
  align-items: center;
}
.headtitle span{
  margin-left: 10px;
}
.dwname{
  font-weight:bold;
  color: white;
  margin-left: 25px;
  padding-top: 15px;
}
.admin{
  margin-top: -5px
}
.admin{
  padding-right: 25px;
}
</style>


// WEBPACK FOOTER //
// src/Header.vue